import { Calendar, Users, Check, Ban, Clock } from "lucide-react";

function formatDateShort(iso) {
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch { return ""; }
}

function StatusBadge({ status }) {
  const map = {
    voting: { label: "In votazione", icon: Clock, cls: "bg-red-50 text-red-700" },
    confirmed: { label: "Confermato", icon: Check, cls: "bg-green-50 text-green-700" },
    cancelled: { label: "Annullato", icon: Ban, cls: "bg-stone-100 text-stone-600" },
  };
  const m = map[status] || map.voting;
  const Icon = m.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.2em] ${m.cls}`}>
      <Icon className="h-2.5 w-2.5" />
      {m.label}
    </span>
  );
}

export default function EventsList({ events, loading, onOpen }) {
  if (loading) {
    return (
      <div className="grid gap-3 sm:grid-cols-2">
        {[1, 2].map((i) => (
          <div key={i} className="h-32 animate-pulse rounded-3xl bg-white border border-[#E8E1D9]" />
        ))}
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="rounded-3xl border border-dashed border-[#E8E1D9] bg-white p-8 text-center">
        <Calendar className="mx-auto h-8 w-8 text-[#C87941]/40" />
        <p className="mt-2 text-sm text-[#5C5855]">
          Nessun Ritrovo per ora. Clicca <strong>Crea uno ZAP</strong> per proporne uno alla famiglia.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {events.map((ev, idx) => {
        const next = ev.final_date || ev.date_options[0];
        return (
          <button
            key={ev.id}
            data-testid={`event-card-${idx}`}
            onClick={() => onOpen(ev.id)}
            className="group flex flex-col items-start rounded-3xl border border-[#E8E1D9] bg-white p-4 text-left transition-all duration-300 hover:-translate-y-1 hover:border-red-300 hover:shadow-md"
          >
            <div className="flex w-full items-center justify-between gap-2">
              <StatusBadge status={ev.status} />
              <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#FF7C43]">
                <Users className="h-3 w-3" /> {ev.votes.length}
              </span>
            </div>
            <h4 className="mt-2 font-display text-lg font-bold leading-snug text-[#2D2926] line-clamp-2">
              {ev.title}
            </h4>
            <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-[#C87941]">
              {ev.status === "confirmed" ? "📍 " : ""}{formatDateShort(next)}
            </p>
            {ev.location && (
              <p className="mt-1 truncate text-xs text-[#5C5855]">{ev.location}</p>
            )}
          </button>
        );
      })}
    </div>
  );
}
